<template>
    <div>
        <el-col :span="7" style="margin-top: 11px; font-size: 18px;">
            <small>Costco Service Requests Count: {{store.state.count}}</small>
        </el-col>
        <el-row style="display: flex; justify-content: flex-end; margin-right: 35px; margin-bottom: 20px;">
            <el-col :span="3">
                <el-radio-group v-model="filter.isHistory"
                                size="mini">
                    <template>
                        <el-radio-button :label="1" :value="1">All</el-radio-button>
                        <el-radio-button :label="0" :value="0">Active</el-radio-button>
                    </template>
                </el-radio-group>
            </el-col>
            <el-col :span="1.8">
                <el-button :loading="exporting"
                           icon="el-icon-download"
                           @click="download"
                           v-if="$isAdmin">{{$t('serviceTickets.export')}}</el-button>
            </el-col>
            <el-col :span="3" style="width:auto;">
                <el-input v-model="filter.serialNumber"
                          placeholder="Serial Number"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
            <el-col :span="3" style="width:22.25%;">
                <el-input v-model="filter.serviceCompany"
                          placeholder="***Look-Up***Service Company contains, e.g. DCS-"
                          prefix-icon="el-icon-search"
                          clearable></el-input>
            </el-col>
            <el-col :span="3" style="width:auto;">
                <el-date-picker v-model="filter.dateFrom"
                                type="date"
                                placeholder="***From Raised on Date***"
                                style="width:100%;"></el-date-picker>
            </el-col>
            <el-col :span="3">
                <el-date-picker v-model="filter.dateTo"
                                type="date"
                                placeholder="***To Raised on Date***"
                                style="width:100%;"></el-date-picker>
            </el-col>
        </el-row>
        <el-table size="mini"
                  :data="tickets"
                  v-loading="loading"
                  class="tickets-table"
                  @sort-change="sortServiceTickets"
                  :row-class-name="tableRowEscalationTime">
            <el-table-column prop="isForInstallation" width="90" label="Is For Installation">
                <template slot-scope="scope">
                    <span>{{ scope.row.isForInstallation ? 'Yes' : 'No' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="customerName"
                             label="Customer Name"
                             sortable="custom"></el-table-column>
            <el-table-column label="Date Created"
                             sortable="custom">
                <template slot-scope="scope">
                    {{scope.row.dateCreated | datetime}}
                </template>
            </el-table-column>
            <el-table-column prop="modelName" label="Model Name"
                             sortable="custom"></el-table-column>
            <el-table-column prop="serialNumber" label="Serial #"
                             sortable="custom"></el-table-column>
            <el-table-column label="Code-Description" min-width="175">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" :content="scope.row.explanationOfIssue" placement="top">
                        <el-tag type="info" size="small" :disable-transitions="true" style="margin-right: 5px;">
                            {{ scope.row.explanationOfIssue }}
                        </el-tag>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="equipmentOperational" :label="'Equipment Operational'">
                <template slot-scope="scope">
                    <span>{{ scope.row.isForInstallation ? 'Yes' : 'No' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="Service Number">
                <template slot-scope="scope">
                    <span>{{ !scope.row.serviceTicketNumber	? '-' : scope.row.serviceTicketNumber}}</span>
                </template>
            </el-table-column>
            <el-table-column label="Operations" fixed="right" width="160">
                <template slot-scope="scope">
                    <el-button v-if="!scope.row.isDeleted && !scope.row.isProcessed" size="mini" @click="editTicket(scope.row.id)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button v-if="scope.row.isDeleted || scope.row.isProcessed" size="mini" @click="showHistoryInfo(scope.row.id)">
                        <i class="el-icon-view"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager"
                       v-if="total !== 0"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="15"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>

        <create-service-ticket-from-draft-dialog :ticketId="ticketToEdit"
                                                 :isHistory="isHistory"
                                                 :visible="createServiceTicketDialogVisible"
                                                 @dialogClosed="editFinished"
                                                 @updated="ticketUpdated"></create-service-ticket-from-draft-dialog>

    </div>
</template>

<script>
    import CreateServiceTicketFromDraftDialog from "./CreateServiceTicketFromDraftDialog";
    import api from "../api";
    import store from "../store.js";

    export default {
        name: "service-ticket-list",
        components: {
            CreateServiceTicketFromDraftDialog
        },
        data() {
            return {
                tickets: [],
                loading: true,
                dialogVisible: false,
                ticketToEdit: null,
                requestToView: null,
                createServiceTicketDialogVisible: false,
                filter: {
                    type: this.$route.params.status || null,
                    serialNumber: "",
                    isHistory: 0,
                    fromDate: "",
                    toDate: "",
                },
                sorting: {},
                currentPage: 1,
                total: 0,
                categories: [],
                store,
                exporting: false,
            };
        },
        watch: {
            filter: {
                deep: true,
                handler: function () {
                    if (this.filter.status === null && this.$route.params.status != null) {
                        window.location.href = "/#/service-tickets";
                    }
                    this.loadServiceRequests();
                }
            }
        },
        created() {
            this.loadServiceRequests();
            this.loadCategories();
        },
        methods: {
           
            ticketUpdated() {
                this.loadServiceRequests();
            },
            loadServiceRequests() {
                this.loading = true;
                api
                    .getServiceRequests(this.currentPage, this.filter, this.sorting)
                    .then(response => {
                        this.loading = false;
                        this.tickets = response.data.items;
                        this.total = response.data.total;
                        this.store.setCount(response.data.total)
                    });
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadServiceRequests();
            },
            editTicket(id) {
                this.ticketToEdit = id;
                this.isHistory = false;
                this.createServiceTicketDialogVisible = true;
            },
            showHistoryInfo(id) {
                this.ticketToEdit = id;
                this.isHistory = true;
                this.createServiceTicketDialogVisible = true;
            },
            editFinished() {
                this.ticketToEdit = null;
                this.createServiceTicketDialogVisible = false;
                this.loadServiceRequests();
            },
            loadCategories() {
                this.loading = true;
                api.getCategories().then(response => {
                    this.loading = false;
                    this.categories = response.data;
                });
            },
            sortServiceTickets(sort) {
                let sortBy = sort.prop;
                if (!sortBy && sort.column != null) {
                    sortBy = sort.column.label;
                }
                let sortOrder = sort.order;
                this.sorting = {
                    sortBy,
                    sortOrder
                };
                if (this.currentPage === 1) {
                    this.loadServiceRequests();
                } else {
                    this.currentPage = 1;
                }
            },
            tableRowEscalationTime({ row, column }) {
                if (row.isProcessed) {
                    return 'success-row';
                } else if (row.isDeleted) {
                    return 'error-row';
                } else {
                    return 'warning-row';
                }
            },
            download() {
                this.exporting = true;
                if (!this.filter.fromDate && !this.filter.dateTo) {
                    var dateToday = new Date();
                    var day = dateToday.getDate();
                    var month = Number(dateToday.getMonth() + 1);
                    var year = Number(dateToday.getFullYear());
                    this.$confirm(
                        this.$t('common.theExportWillBeGeneratedForAPeriodOfOneYear') + (year - 1) + '/' + month + '/' + day + " - " + year + '/' + month + '/' + day + this.$t('common.sinceTheDateRangeWasNotSelectedPleaseConfirm'),
                        "Warning",
                        {
                            confirmButtonText: this.$t('common.OK'),
                            cancelButtonText: this.$t('common.cancel'),
                            type: "warning"
                        }
                    )
                        .then(() => {
                            api.download(this.filter, this.sorting).then(() => {
                                this.exporting = false;
                                this.$message({
                                    title: this.$t('common.success'),
                                    message: this.$t('common.exportWasGeneratedSuccesfully'),
                                    type: "success"
                                });
                            });
                        }).catch(_ => { this.exporting = false; });
                }
                else {
                    api.download(this.filter, this.sorting).then(() => {
                        this.exporting = false;
                        this.$message({
                            title: this.$t('common.success'),
                            message: this.$t('common.exportWasGeneratedSuccesfully'),
                            type: "success"
                        });
                    });
                }
            }
        }
    };
</script>
<style scoped>
    .green-row {
        background: lightgreen;
    }

    .blue-row {
        background: blue;
    }
</style>

<style>
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .el-table .error-row {
        background: #f2999a
    }
</style>




// WEBPACK FOOTER //
// ClientApp/app/costcoservicerequests/components/CostcoServiceRequestsList.vue